import { render, staticRenderFns } from "./LaborRelations.vue?vue&type=template&id=dd26d998&scoped=true&"
import script from "./LaborRelations.vue?vue&type=script&lang=js&"
export * from "./LaborRelations.vue?vue&type=script&lang=js&"
import style0 from "./LaborRelations.vue?vue&type=style&index=0&id=dd26d998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd26d998",
  null
  
)

export default component.exports